import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryPetShopIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-petshop"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M11.7944 11.7359C13.2713 12.5868 14.7921 19.0275 13.7263 20.8698C13.1578 21.8524 11.7258 22.339 10.249 21.488C9.51052 21.0626 8.31665 19.3374 7.70127 18.9828C7.0859 18.6282 4.88871 18.5608 4.0273 18.0645C3.16579 17.5681 2.74821 16.0188 3.3878 14.9135C4.64499 13.2257 9.9669 10.7221 11.7944 11.7359Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      d="M9.40939 4.86221C8.88608 6.70151 9.34638 8.41186 10.4352 8.68482C11.5244 8.95749 12.8295 7.69216 13.3532 5.85276C13.8765 4.01337 13.4162 2.29638 12.3274 2.02352C12.237 2.00764 12.1481 2 12.0603 2C10.8442 2.0001 9.88608 3.46794 9.40939 4.86221Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M15.2382 6.69025C13.9038 8.06261 13.4576 9.82774 14.239 10.6324C15.0203 11.4373 16.7347 10.9809 18.0693 9.60885C19.404 8.23638 19.8566 6.47126 19.0752 5.66643C18.7831 5.37508 18.4371 5.25769 18.0685 5.25769C17.0853 5.25779 15.9422 6.09297 15.2382 6.69025Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M3.36752 8.14612C2.94099 9.91386 3.4435 11.6008 4.48651 11.9088C5.52963 12.2169 6.71797 11.0306 7.1445 9.2629C7.57134 7.49516 7.07516 5.81496 6.03204 5.50722C5.92149 5.48692 5.81435 5.47717 5.71053 5.47717C4.51516 5.47727 3.75847 6.76662 3.36752 8.14612Z"
    />
    <path
      className="fill-accent-primaryActive"
      d="M16.9237 12.8329C15.3643 13.7297 14.5345 15.2089 15.0718 16.1368C15.6091 17.0648 17.3095 17.0934 18.8686 16.1965C20.4281 15.2997 21.2578 13.8205 20.7205 12.8926C20.4064 12.3804 19.8499 12.1932 19.2317 12.1932C18.4348 12.1933 17.5356 12.5047 16.9237 12.8329Z"
    />
  </Svg>
));

CategoryPetShopIcon.displayName = 'CategoryPetShopIcon';
